import React from 'react'

export const About = () => (
  <div>
    <h2>About</h2>
    <p>秋葉原モテ研究所では、日々「モテ」を研究する最先端学術研究機関です。</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/About/index.js